import { render } from "./ViewIngestion.vue?vue&type=template&id=32c34ce5"
import script from "./ViewIngestion.vue?vue&type=script&lang=js"
export * from "./ViewIngestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__